import { Button } from "@/components/ui/form";

export function SectionAddButton({
  label = "Add",
  open,
  onClick,
}: {
  label?: string;
  open: boolean;
  onClick: () => void;
}) {
  return (
    <Button type="button" variant={open ? "secondary" : "primary"} size="sm" onClick={onClick}>
      {open ? "Cancel" : label}
    </Button>
  );
}
